import axios from 'axios'

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_V3_URL
});

axiosInstance.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response && error.response.status === 401) {
            if (
                !error.response.config.url.endsWith('/authentication/login')
                &&
                !error.response.config.url.endsWith('/authentication/logout')
            ) {
                window.location.href = process.env.VUE_APP_GROEPSAPP_V3_URL  + '/logout'
            }
        }
        return Promise.reject(error)
    }
)

const requests = {
    getHeaders() {
        // eslint-disable-next-line no-undef
        const store = app.config.globalProperties.$store;

        let deviceToken = null
        if (store.getters.deviceToken) {
            deviceToken = store.getters.deviceToken
        }

        let sessionToken = null
        if (store.getters.session && store.getters.session.session_token) {
            sessionToken = store.getters.session.session_token
        }

        return {
            headers: {
                'device-token': deviceToken,
                'session-token': sessionToken
            }
        }
    },
    getDeprecatedBodyAuthentication() {
        const headers = this.getHeaders();
        return {
            session_token: headers.headers['session-token'],
            device_token: headers.headers['device-token']
        }
    },
    get(url) {
        return axiosInstance
            .get(url, this.getHeaders())
            .then(response => response.data)
            .catch(response => {
                console.error({ error: response });
            })
    },
    post(url, data, config = {}) {
        // eslint-disable-next-line no-undef
        const mergedConfig = app.config.globalProperties.$lodash().defaultsDeep(this.getHeaders(), config);
        return axiosInstance
            .post(url, data, mergedConfig)
            .then(response => {
                return response.data
            })
            .catch(error => {
                if (error && error.response && error.response.data) {
                    return error.response.data
                }
                return error
            })
    },
    put(url, data) {
        return axiosInstance
            .put(url, data, this.getHeaders())
            .then(response => {
                return response.data
            })
            .catch(response => {
                console.error({ error: response });
            })
    },
    delete(url) {
        return axiosInstance
            .delete(url, this.getHeaders())
            .then(response => {
                return response.data
            })
            .catch(response => {
                console.error({ error: response });
            })
    }
};

export const VueRequest = {
    install(app) {
        app.provide('$request', requests);
        app.config.globalProperties.$request = requests;
    }
}
